<template>
  <div v-if="stats" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Card 1: Total Clientes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Clientes</span>
        <div class="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-lg">
          <i class="fa fa-users" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-gray-900">{{ stats.total ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Registrados en la plataforma</p>
      </div>
    </div>

    <!-- Card 2: Clientes con Deuda -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Con Saldo Pendiente</span>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-lg">
          <i class="fa fa-user-clock" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-amber-600">{{ stats.with_debt ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Clientes con cuentas por cobrar</p>
      </div>
    </div>

    <!-- Card 3: Monto Total por Cobrar -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total por Cobrar</span>
        <div class="w-10 h-10 rounded-xl bg-red-50 text-red-600 flex items-center justify-center text-lg">
          <i class="fa fa-hand-holding-usd" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-red-600">{{ formatCurrency(stats.total_receivable ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">Capital pendiente de pago</p>
      </div>
    </div>

    <!-- Card 4: Nuevos este Mes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Nuevos este Mes</span>
        <div class="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-lg">
          <i class="fa fa-user-plus" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-emerald-600">{{ stats.new_this_month ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Nuevos registros del mes actual</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientStats',

  props: {
    stats: {
      type: Object,
      default: () => ({
        total: 0,
        with_debt: 0,
        total_receivable: 0,
        new_this_month: 0,
      }),
    },
  },

  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value || 0)
    },
  },
}
</script>
